<template>
  <div>
    <button
      @click.prevent="closeConversation()"
      id="id-close-convo-btn"
      type="button"
      class="btn btn-rounded btn-danger btn-block"
    >
      Close Conversation
    </button>
  </div>
</template>


<script>
/* eslint-disable */
import { EventBus } from "@/events/eventBus";
import CloseConversation from "../conversations/CloseConversation.vue";

export default {
  props: {
    conversationId: String
  },
  methods: {
    closeConversation() {
      EventBus.$emit("closeImageViewerModal");
      EventBus.$emit("closeVideoModal");

      setTimeout(async () => {
        const $ = window.$;
        $("#id-modal-container").modal({
          backdrop: "static"
        });
        EventBus.$emit("open", {
          component: CloseConversation,
          title: "Are you sure you want to terminate this conversation thread?",
          closeOnClick: true,
        });
      }, 500);
    }
  }
};
</script>
